var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-box"},[_c('el-tabs',{on:{"tab-click":_vm.query},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('el-tab-pane',{attrs:{"label":"优惠券","name":"ref1"}},[_c('Coupon',{ref:"ref1"})],1),_c('el-tab-pane',{attrs:{"label":"兑换码","name":"ref2"}},[_c('ExchangeCode',{ref:"ref2"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }